var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.selectedEffect === 'outerGlow')?[_c('OuterGlowEffect',{attrs:{"target":_vm.target}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }